import { T } from "../constants/theme";

export default function Btn({
  children,
  onClick,
  variant = "primary",
  disabled,
  full,
  small,
}) {
  const styles = {
    primary: {
      background: T.saffron,
      color: T.white,
      border: "none",
    },

    outline: {
      background: "transparent",
      color: T.indigo,
      border: `1.5px solid ${T.indigo}`,
    },

    ghost: {
      background: "transparent",
      color: T.gray600,
      border: "none",
    },
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        ...styles[variant],
        padding: small ? "8px 18px" : "12px 28px",
        borderRadius: 8,
        fontWeight: 700,
        fontSize: small ? 13 : 15,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        width: full ? "100%" : "auto",
        letterSpacing: "0.01em",
        transition: "opacity 0.15s, transform 0.1s",
      }}
      onMouseEnter={(e) => !disabled && (e.target.style.opacity = "0.88")}
      onMouseLeave={(e) => !disabled && (e.target.style.opacity = "1")}
    >
      {children}
    </button>
  );
}